module.exports = __webpack_public_path__ + "static/media/Follower_Button-20.fee9b7c8.png";